import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "../../../environments/environment";
@Injectable({
  providedIn: 'root'
})
export class ProductService {

  urlBase = environment.urlApi;
  constructor(private http: HttpClient) { }

  productByCategory(idCategorie,startIndex,itemsPerPage=12,level="TSICOD2",fournisseurs=[])
  {
    var idsf = fournisseurs.join();
    return this.http.get(this.urlBase+"/products/searchByCategory?level="+level+"&code="+idCategorie+"&fournisseurs=["+idsf+"]&perpage="+itemsPerPage+"&startIndex="+startIndex);
  }

  productByMarkCategories(idfournisseur,idCategories,startIndex=1,itemsPerPage=12)
  {
    return this.http.get(this.urlBase+"/products/searchByFournisseur?fournisseur="+idfournisseur+"&categories=["+idCategories.join()+"]&level=TSICOD2&perpage="+itemsPerPage+"&startIndex="+startIndex);
  }

  searchByKeyWord(word,startIndex)
  {
    return this.http.get(this.urlBase+"/products/searchByDesc?perpage=12&startIndex="+startIndex+"&search="+word);
  }

  productByCode(id)
  {
    return this.http.get(this.urlBase+"/products/"+id+"/details");
  }

  getProductByMarque(idfournisseur,startIndex=1,itemsPerPage=12)
  {
    return this.http.get(this.urlBase+"/products/searchByFournisseur?fournisseur="+idfournisseur+"&perpage="+itemsPerPage+"&startIndex="+startIndex);
  }
  searchBySerie(idfournisseur,startIndex, itemsPerPage=12){
    return this.http.get(this.urlBase+"/products/searchByserie?fournisseur="+idfournisseur+"&perpage="+itemsPerPage+"&startIndex="+startIndex);
  }
  // productsBySerie(idSerie){
  //   return this.http.get(this.urlBase+"/products/"+idSerie+"/TSICOD3");
  // }
  productsBySerie(idSerie,idfournisseur){
    return this.http.get(this.urlBase+"/products/searchByFournisseur?fournisseur="+idfournisseur+"&categories=["+idSerie+"]&level=TSICOD3&perpage=2000");
  }
//new
getProductsPromos(startIndex, itemsPerPage=12){
  return this.http.get(this.urlBase+"/products/promo?perpage="+itemsPerPage+"&startIndex="+startIndex);
}

}
